import { useQuery } from '@tanstack/react-query';
import sportsApi from '../../../utils/sportsApi';
import {
    Query,
    StadiumFanAnalytics,
    AnalyticsInput,
} from '../../../types/inVenue';
import { CommonKey } from '../../../types/api';

const fetchAnalytics = async ({
    rightsholder,
    season,
    clientId,
    gameDates,
    sectionIds,
    groupBy,
}: AnalyticsInput): Promise<StadiumFanAnalytics[]> => {
    if (!rightsholder?.id) return [];
    const hasDates =
        gameDates?.length > 0 || (season?.startDate && season?.endDate);
    if (!hasDates) return [];
    // eslint-disable-next-line no-undef
    const query: Partial<Query> = {
        groupBy: groupBy.sort().join(','),
        rightsholderId: rightsholder?.id,
        ...(sectionIds && { sectionIds }),
        ...(gameDates?.length > 0
            ? { dates: gameDates.sort().join(',') }
            : season
              ? {
                    startDate: season.startDate,
                    endDate: season.endDate,
                }
              : {}),
    };
    const result: StadiumFanAnalytics[] = await sportsApi
        .url(`/clients/${clientId}/in-stadium/fan-analytics`)
        .query(query as Record<string, any>)
        .get()
        .json();

    return result;
};

const useAnalytics = ({
    clientId,
    rightsholder,
    season,
    gameDates,
    sectionIds,
    groupBy,
}: AnalyticsInput) =>
    useQuery({
        queryKey: [
            CommonKey.InVenueAnalytics,
            clientId,
            rightsholder?.id,
            season?.id,
            gameDates?.sort().join('-'),
            sectionIds?.sort().join('-'),
            groupBy?.sort().join('-'),
        ],
        queryFn: (): Promise<StadiumFanAnalytics[]> =>
            fetchAnalytics({
                rightsholder,
                season,
                clientId,
                gameDates,
                sectionIds,
                groupBy,
            }),
    });

export default useAnalytics;
